import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'
import { RedirectSitePortalToHomeIfPublicNavigationGuard } from '../../guards'
import { MultiFactorAuthenticationModule } from '../../lib/multifactor-authentication-module/multifactor-authentication.module'
import { MfaChallengePage } from './challenge/mfa-challenge'
import { MfaRecoverAccountPage } from './recover-account/mfa-recover-account.page'

@NgModule({
  imports: [
    MultiFactorAuthenticationModule,
    RouterModule.forChild([
      {
        path: AppPaths.MultiFactorAuthentication,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        children: [
          {
            path: '',
            component: MfaChallengePage,
            data: {
              hideSideNav: true,
            },
          },
          {
            path: 'recover-account',
            component: MfaRecoverAccountPage,
            data: {
              hideSideNav: true,
            },
          },
        ],
      },
    ]),
  ],
  declarations: [MfaRecoverAccountPage, MfaChallengePage],
})
export class MultifactorAuthenticationPagesModule {}
